import { buildRestUrl, fetchJson } from '../../shared/api/client';
import type { WpPost } from '../types';

export const fetchPosts = async (perPage = 100): Promise<WpPost[]> => {
  const url = buildRestUrl('/wp/v2/posts', {
    per_page: String(perPage),
    _fields: 'id,date,modified,slug,link,title,excerpt,author,featured_media',
  });
  return fetchJson<WpPost[]>(url);
};

export const fetchPostById = async (id: number): Promise<WpPost> => {
  const url = buildRestUrl(`/wp/v2/posts/${id}`);
  return fetchJson<WpPost>(url);
};
